"use client";

import { ErrorState } from "@gerama/ui";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="mx-auto max-w-6xl px-4 py-6 md:py-10">
      <ErrorState variant="immersive" title="بارگذاری هنرمندان ناموفق بود" onRetry={reset} />
    </main>
  );
}
